import React from 'react'
import styled from 'styled-components'

import logo from '../../../../assets/images/logos/bluesite-hub-color.png'

const Image = styled.img`
  width: ${(props: { width: string }) => props.width || '100%'};
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
`

interface IProps {
  width?: string
}

const Logo = (props: IProps) => {
  const { width } = props

  return <Image width={width || ''} src={logo} alt="Bluesite HR Hub" />
}

export default Logo
